import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
        icon = _context$props.icon,
        title = _context$props.title;
    var vnodes = [];

    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(h("i", {
          "class": [icon, 'sub-el-icon']
        }));
      } else {
        vnodes.push(h("svg-icon", {
          "attrs": {
            "icon-class": icon
          }
        }));
      }
    }

    if (title) {
      vnodes.push(h("span", {
        "slot": 'title'
      }, [title]));
      vnodes.push(h("div", {
        "class": 'sidebar-title'
      }, [title]));
    }

    return vnodes;
  }
};